/**
 * 時間前市場 板 (OrderBook) 取得 hook。
 */
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listBiddingMarketOrderBook } from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service-BiddingIntradayMarketService_connectquery'
import {
  ListBiddingMarketOrderBookRequestSchema,
  type ListBiddingMarketOrderBookResponse,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useMarketOrderBook(
  deliveryDate: ProtoDate | undefined,
  timeCode: number,
  enabled: boolean,
): UseQueryResult<ListBiddingMarketOrderBookResponse, ConnectError> {
  return useQuery(
    listBiddingMarketOrderBook,
    create(ListBiddingMarketOrderBookRequestSchema, {
      deliveryDate,
      timeCode,
    }),
    {
      enabled: enabled && deliveryDate !== undefined && timeCode > 0,
      // 手動更新 + stream invalidate で refetch する。 自動 polling はしない。
      staleTime: Infinity,
      // backend gRPC 未接続 (= port-forward 切れ等) でも error boundary に飛ばさず、
      // 呼び出し側でローディング表示にとどめる (= 全画面エラーにしない)。
      throwOnError: false,
      // error 中だけ一定間隔で再試行し、 backend 復帰で自動回復する。
      refetchInterval: (query) =>
        query.state.status === 'error' ? 5000 : false,
    },
  )
}
